import type { SubscriptionMeResponse } from "@/src/types/subscriptionPlan.types";

/**
 * Last successful `/subscriptions/me` response — used only to show data instantly
 * while a fresh request is in flight. Does NOT skip API calls.
 */
type SnapshotEntry = {
  userId: string;
  data: SubscriptionMeResponse;
  fetchedAt: number;
};

let entry: SnapshotEntry | null = null;

export function getHomeownerSubscriptionSnapshot(
  userId: string,
): SubscriptionMeResponse | null {
  if (!entry || entry.userId !== userId) return null;
  return entry.data;
}

export function setHomeownerSubscriptionSnapshot(
  userId: string,
  data: SubscriptionMeResponse,
): void {
  entry = { userId, data, fetchedAt: Date.now() };
}

export function clearHomeownerSubscriptionCache(): void {
  entry = null;
}

/** @deprecated Use getHomeownerSubscriptionSnapshot — kept for any stale imports */
export function getStaleHomeownerSubscriptionCache(
  userId: string,
): SubscriptionMeResponse | null {
  return getHomeownerSubscriptionSnapshot(userId);
}
